/**
 * Le backend Python sérialise `datetime.now().isoformat()` sans suffixe
 * timezone (ex. "2026-04-30T00:06:03.375532"). Le serveur tourne en UTC,
 * mais JavaScript interprète ces chaînes comme heure locale, ce qui produit
 * un décalage de plusieurs heures pour les utilisateurs hors UTC.
 *
 * Ce helper force l'interprétation UTC quand la chaîne est "naïve"
 * (pas de Z, pas d'offset). Les chaînes déjà tagged (Z ou +HH:MM) restent
 * inchangées.
 */
export function parseServerDate(s: string | null | undefined): Date | null {
  if (!s) return null;
  const hasTimezone = /[Z]|[+-]\d{2}:?\d{2}$/.test(s);
  return new Date(hasTimezone ? s : `${s}Z`);
}

export function parseServerDateMs(s: string | null | undefined): number {
  const d = parseServerDate(s);
  return d ? d.getTime() : 0;
}
